/**
 * Broker announcements client (DEV-3636, Skynet.Loans behind the loans gateway).
 * GET /api/brokerAnnouncements returns the active announcements the authenticated
 * broker should see (channel wire / lender guidelines + product updates), scoped
 * server-side to the caller's company. Returns an empty list until the
 * announcements table migration deploys.
 *
 * Response shape:
 *   { announcements: [{ id, title, body, severity, effectiveFrom, expiresAt }],
 *     asOf }
 */
export class BrokerAnnouncementsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAnnouncements({ config = {} } = {}) {
    return this.#http.get('/api/command-center/announcements', config);
  }
}
